import { CharacterList } from './CharacterList'
import { withCharacterList } from './withCharacterList'

const ConnectedCharacterList = withCharacterList(CharacterList)

export { ConnectedCharacterList as CharacterList }
